import React from 'react';
import { Select, Button } from './FormControls';
import { StepProps } from './types';

interface StepLifestyleProps extends StepProps {
  onNext: () => void;
  onBack: () => void;
}

const StepLifestyle: React.FC<StepLifestyleProps> = ({ formData, onChange, onNext, onBack }) => (
  <div className="space-y-6 animate-in fade-in slide-in-from-right-4 duration-500">
    <h3 className="text-2xl font-black text-gray-900">Lifestyle & Wellness</h3>

    <div className="space-y-6">
      <div className="space-y-3">
        <label className="block text-sm font-bold text-gray-700">Are you into personal development or wellness?</label>
        <div className="flex gap-4">
          {['Yes', 'No'].map(opt => (
            <label key={opt} className="flex items-center gap-2 cursor-pointer">
              <input
                type="radio"
                name="goesToGym"
                checked={formData.goesToGym === opt}
                onChange={() => onChange({ goesToGym: opt as 'Yes' | 'No' })}
                className="w-4 h-4 text-purple-600 focus:ring-purple-400"
              />
              <span className="text-sm font-medium text-gray-700">{opt}</span>
            </label>
          ))}
        </div>
      </div>

      <Select
        label="How often do you practice self-care or wellness routines?"
        value={formData.workoutFrequency}
        onChange={v => onChange({ workoutFrequency: v })}
        options={[
          "1-2 times per week",
          "3-4 times per week",
          "5-6 times per week",
          "Daily"
        ]}
        required
      />

      <div className="space-y-3">
        <label className="block text-sm font-bold text-gray-700">Do you have a good filming environment (quiet space, good lighting)?</label>
        <div className="flex gap-4">
          {['Yes', 'No'].map(opt => (
            <label key={opt} className="flex items-center gap-2 cursor-pointer">
              <input
                type="radio"
                name="gymAccess"
                checked={formData.gymAccessForFilming === opt}
                onChange={() => onChange({ gymAccessForFilming: opt as 'Yes' | 'No' })}
                className="w-4 h-4 text-purple-600 focus:ring-purple-400"
              />
              <span className="text-sm font-medium text-gray-700">{opt}</span>
            </label>
          ))}
        </div>
      </div>

      <div className="space-y-2">
        <label className="block text-sm font-bold text-gray-700">Describe your personal growth journey in 2-3 sentences</label>
        <p className="text-xs text-gray-500">We're looking for personality and authenticity. Tell us what self-improvement means to you.</p>
        <textarea
          required
          rows={4}
          className="w-full px-5 py-4 bg-gray-50 border border-gray-200 rounded-2xl focus:ring-2 focus:ring-purple-400 outline-none transition-all font-medium resize-none"
          value={formData.fitnessJourney}
          onChange={e => onChange({ fitnessJourney: e.target.value })}
        />
      </div>
    </div>

    <div className="flex justify-between pt-6">
      <Button variant="secondary" onClick={onBack}>← Back</Button>
      <Button onClick={onNext}>Next Step →</Button>
    </div>
  </div>
);

export default StepLifestyle;
